<template>
	<div class="container">
		<h1 class="text-center my-2 mt-4">Bienvenido a Capital de Trabajo</h1>
		<h2 class="text-center my-2 text-secondary">Trabajo para todos los peruanos</h2>
		<div class="row row-cols-2">
			<div class="col">
				<div class="encabezado py-2 px-3"> Bolsa de trabajo </div>
				<p class="p-3">Capital de Trabajo es la puerta de acceso al mercado de trabajo en internet. ¡Encuentre trabajo ya! Podrá consultar nuestro directorio de empresas, y buscar empleo en nuestra bolsa de trabajo on-line.</p>
				<div class="d-flex justify-content-center mx-auto">
					<button class="btn btn-primary" @click="$router.push('buscador')">Ver empleos</button>
				</div>
			</div>
			<div class="col">
				<div class="encabezado py-2 px-3"> Bolsa de trabajo </div>
				<p class="p-3">Agregue su currículum gratis a nuestra base de datos y dese a conocer a cientos de empresas de todo el país. Además le regalaremos una página web gratis para poder tener acceso a su currículum desde internet.</p>
				<div class="d-flex justify-content-center mx-auto">
					<button class="btn btn-primary" @click="$router.push({name: 'crearCV'})">Subir CV</button>
				</div>

			</div>
		</div>
		<div class="row row-cols-2 mt-4">
			<div class="col">
				<div class="encabezado py-2 px-3"> Ofertas en su correo </div>
				<p class="p-3">Suscríbase a nuestra bolsa de trabajo y todas las semanas le enviaremos gratuitamente a su buzón de correo electrónico el listado con las nuevas ofertas de empleo que salgan publicadas en Capital de Trabajo.</p>
				<div class="d-flex justify-content-center mx-auto"><button class="btn btn-primary">Suscribirme</button></div>
			</div>
			<div class="col">
				<div class="encabezado py-2 px-3"> Publicar aviso </div>
				<p class="p-3">En Capital de Trabajo su empresa podrá publicar todas sus ofertas de empleo gratis, crear una página web con los datos de su empresa , y buscar entre miles de currículos a los mejores profesionales del país.</p>
				<div class="d-flex justify-content-center mx-auto">
					<button class="btn btn-primary" @click="$router.push({name: 'publicarComplejo'})">Publicar aviso</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import {collection, getDocs, query, where, orderBy, startAt, endAt } from 'firebase/firestore';
	
	export default{
		data(){
			return {
			}
		},
		name: 'Bienvenida',
		props:['variable1', 'refTodos', 'departamentos'],
		async mounted(){
			console.log('estoy en bienvenido, con:', this.variable1);
				
			
		}
	}
</script>